import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function CouponDiscount({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>CouponDiscount</title>
      <path
        d="M2.31525 9.63594L2.07079 10.345L2.31525 9.63594ZM2.31525 14.3641L2.07079 13.655L2.31525 14.3641ZM21.6847 14.3641L21.9292 13.655L21.6847 14.3641ZM21.6847 9.63594L21.4403 8.92691L21.6847 9.63594ZM6 3.25C3.37665 3.25 1.25 5.37665 1.25 8H2.75C2.75 6.20507 4.20507 4.75 6 4.75V3.25ZM18 3.25H6V4.75H18V3.25ZM22.75 8C22.75 5.37665 20.6234 3.25 18 3.25V4.75C19.7949 4.75 21.25 6.20507 21.25 8H22.75ZM22.75 9.22305V8H21.25V9.22305H22.75ZM20.75 12C20.75 11.2345 21.242 10.5819 21.9292 10.345L21.4403 8.92691C20.1667 9.36603 19.25 10.575 19.25 12H20.75ZM21.9292 13.655C21.242 13.4181 20.75 12.7655 20.75 12H19.25C19.25 13.425 20.1667 14.634 21.4403 15.0731L21.9292 13.655ZM22.75 16V14.777H21.25V16H22.75ZM18 20.75C20.6234 20.75 22.75 18.6234 22.75 16H21.25C21.25 17.7949 19.7949 19.25 18 19.25V20.75ZM6 20.75H18V19.25H6V20.75ZM1.25 16C1.25 18.6234 3.37665 20.75 6 20.75V19.25C4.20507 19.25 2.75 17.7949 2.75 16H1.25ZM1.25 14.777V16H2.75V14.777H1.25ZM2.55972 15.0731C3.83334 14.634 4.75 13.425 4.75 12H3.25C3.25 12.7655 2.75802 13.4181 2.07079 13.655L2.55972 15.0731ZM4.75 12C4.75 10.575 3.83334 9.36603 2.55972 8.92691L2.07079 10.345C2.75802 10.5819 3.25 11.2345 3.25 12H4.75ZM1.25 8V9.22305H2.75V8H1.25ZM2.55972 8.92691C2.62653 8.94994 2.75 9.03795 2.75 9.22305H1.25C1.25 9.78862 1.64428 10.1979 2.07079 10.345L2.55972 8.92691ZM2.75 14.777C2.75 14.962 2.62653 15.0501 2.55972 15.0731L2.07079 13.655C1.64428 13.8021 1.25 14.2114 1.25 14.777H2.75ZM21.4403 15.0731C21.3735 15.0501 21.25 14.962 21.25 14.777H22.75C22.75 14.2114 22.3557 13.8021 21.9292 13.655L21.4403 15.0731ZM21.25 9.22305C21.25 9.03795 21.3735 8.94994 21.4403 8.92691L21.9292 10.345C22.3557 10.1979 22.75 9.78862 22.75 9.22305H21.25Z"
        fill={color ?? 'currentColor'}
      />
      <circle
        cx="9.79883"
        cy="9.7986"
        r="0.791538"
        transform="rotate(45 9.79883 9.7986)"
        fill={color ?? 'currentColor'}
      />
      <circle
        cx="14.2012"
        cy="14.2014"
        r="0.791538"
        transform="rotate(45 14.2012 14.2014)"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M9.76067 14.2388L14.2383 9.76123"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
